export enum Permission {
  // Legacy: Deprecate. Not used
  CampaignManagement = 'campaign-management',
  CampaignManagementView = 'campaign_management.view',
  CampaignManagementModify = 'campaign_management.modify',
  DraftSelectionModify = 'draft_selection.modify',
  // same permission in retailer collection flyers access
  Flyers = 'flyers.view',
  CampaignManagementPageBuilderModify = 'campaign_management_page_builder.modify',
  CampaignManagementPageBuilderView = 'campaign_management_page_builder.view',
}
